import $ from "jquery";
import "flickity-imagesloaded";

class ProductsSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            // autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            cellSelector: '.product-miniature',
            cellAlign: 'left',
            imagesLoaded: true,
        };

        if(this.$el.length) {
            
            if (document.body.clientWidth >= 1200) {
                if (this.$el[0].children.length > 3) {
                    this._createSlider();
                    this.$el[0].classList.remove('no-slider');
                }
            } else if (this.$el[0].children.length > 2 && document.body.clientWidth >= 768) {
                this._createSlider();
                this.$el[0].classList.remove('no-slider');

            } else if (this.$el[0].children.length > 1) {
                this._createSlider();
                this.$el[0].classList.remove('no-slider');
            }
        }
    }

    _createSlider() {
        this.$el.flickity(this.options);
    }
}

export default ProductsSlider;
